import './main.css'
import {Columns, MainLayout} from "../../../palette/Palette";
import Info from "./info/Info";
import {useEffect, useRef, useState} from "react";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MainRoutes from "../../../routes/MainRoutes";
import {useMountedState} from "../../../utils/UnMounted";

function Main() {

    const parentRef = useRef(null);

    const [heightContainer, setHeightContainer] = useState(null)
    const [login, setLogin] = useState(true)
    const [create, setCreate] = useState(false)
    const [recover, setRecover] = useState(false)

    const isMounted = useMountedState()

    const matchOne = useMediaQuery('(min-height:510px)');
    const matchTwo = useMediaQuery('(min-height:450px)');

    useEffect(() => {
        if (isMounted()) {
            if (parentRef.current) {
                const {offsetHeight} = parentRef.current
                setHeightContainer(offsetHeight)
            }
        }
    }, [parentRef, matchOne, matchTwo, isMounted]);

    return (
        <main>
            <div className="session-container">
                <div className="session-container-forms" ref={parentRef}>
                    <Columns>
                        <Info heightContainer={heightContainer} setRecover={setRecover} setLogin={setLogin}
                              setCreate={setCreate} login={login} create={create} recover={recover}/>
                        <MainLayout height={heightContainer} positionC padding={10}>
                            <MainRoutes/>
                        </MainLayout>
                    </Columns>
                </div>
            </div>
        </main>
    )
}

export default Main



